import React from "react";
import { MainDialog } from "../Dialgos/MainDialog";
import { useTranslation } from "react-i18next";
import CouponForm from "./form/CouponForm";
import { indexStore } from "src/store/indexStore";
import { CiEdit } from "react-icons/ci";

const EditCouponModel = ( props ) => {
  const { t } = useTranslation();
  const { coupon, updateCouponFunction, setCoupon } = indexStore();
  const editCoupon = (element) => {
    setCoupon(element);
  };
  const handleSubmit = (values) => {
    updateCouponFunction({ ...values, id: coupon.id });
  };
  return (
    <MainDialog
      trigger={
        <CiEdit
          className="text-xl cursor-pointer"
          onClick={() => editCoupon(props.element)}
        />
      }
      title={`${t("gloabl.edit")} ${t(`gloabl.copun`)}`}
    >
      <CouponForm onSubmit={handleSubmit} editMode={true} datasource={coupon} />
    </MainDialog>
  );
};

export default EditCouponModel;
